import { css } from "styled-components";

export const satoshi500 = css`
	font-family: "Satoshi", sans-serif;
	font-weight: 500;
	line-height: 100%;
	letter-spacing: 2%;
`;

export const satoshi700 = css`
	font-family: "Satoshi", sans-serif;
	font-weight: 700;
	line-height: 100%;
	letter-spacing: 2%;
`;

export const satoshi900 = css`
	font-family: "Satoshi", sans-serif;
	font-weight: 900;
	line-height: 100%;
	letter-spacing: 2%;
`;
